import { ComplexBase } from '@syncfusion/ej2-react-base';
export class SplitButtonItemDirective extends ComplexBase {
}
SplitButtonItemDirective.moduleName = 'splitButtonItem';
export class SplitButtonItemsDirective extends ComplexBase {
}
SplitButtonItemsDirective.propertyName = 'items';
SplitButtonItemsDirective.moduleName = 'splitButtonItems';
